<template>
  <empty-tag v-if="item.header && item.children">
    <li class="nav-title">
      {{ item.title }}
    </li>

    <nav-item v-for="child in item.children" :key="child.title" :item="child" />
  </empty-tag>

  <li v-else :class="classes">
    <a v-if="item.children" href="javascript:void(0)" @click.prevent="toggleOpen">
      <i v-if="item.icon" class="fal" :class="item.icon" />

      <span class="nav-link-text">{{ item.title }}</span>

      <b class="collapse-sign">
        <em class="fal" :class="{ 'fa-angle-up': isOpened, 'fa-angle-down': !isOpened }" />
      </b>
    </a>

    <router-link
      v-else
      active-class="active"
      :to="{ name: item.name, params: item.params, query: item.query }"
    >
      <i v-if="item.icon" class="fal" :class="item.icon" />

      <span class="nav-link-text">{{ item.title }}</span>
    </router-link>

    <slide>
      <ul v-if="isOpened && item.children">
        <nav-item v-for="child in item.children" :key="child.title" :item="child" />
      </ul>
    </slide>
  </li>
</template>

<script>
import { mapState } from 'vuex';

import Slide from '@/components/animations/Slide.vue';

import EmptyTag from './EmptyTag.vue';

// @vuese
// Element bocznego menu
// @group AppLayout
export default {
  name: 'NavItem',
  components: { Slide, EmptyTag },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      opened: false
    };
  },
  computed: {
    ...mapState({
      isFiltering: state => state.layout.isFiltering
    }),
    hasChildren() {
      return this.item.children && this.item.children.length;
    },
    classes() {
      const classes = [];
      if (this.isActive) {
        classes.push('active');
      }
      if (this.isOpened) {
        classes.push('open');
        classes.push('active');
      }
      return classes.join(' ');
    },
    isActive() {
      if (this.$route.name === this.item.name) {
        return true;
      }
      if (this.item.children) {
        return this.item.children.map(child => child.name).includes(this.$route.name);
      }
      return this.$route.name === this.item.name;
    },
    isOpened() {
      return this.opened || this.isFiltering;
    }
  },
  created() {
    if (this.item.children && this.isActive) {
      this.opened = true;
    }
  },
  methods: {
    // @vuese
    // Pokazuje podmenu
    toggleOpen() {
      this.opened = !this.opened;
    }
  }
};
</script>
